// The "is it in the right thread?" card: which event, which thread it is in now, and the question.
// "Máshová…" opens a picker right in the card (every thread, as "Parent › Thread").
import { useState } from 'react';
import { api } from '../api';
import { day } from '../ui';

const KIND: Record<string, string> = { payment: 'fizetés', message: 'üzenet', task: 'teendő', exam: 'vizsga', plan: 'terv', class: 'óra', note: 'jegyzet' };

interface Lite { id: string; name: string; parent_id: string | null; status: string }
let cache: Promise<Lite[]> | null = null;
const threads = () => (cache ??= api<Lite[]>('/api/threads').catch((e) => { cache = null; throw e; }));

export function PlacementCard({ x, onAnswer, onMoved }: {
  x: { event_id: string; thread_id: string; thread: string; parent?: string | null; occurred_at: string; kind: string; text: string };
  onAnswer: (action: 'ok' | 'none') => void;
  onMoved?: () => void;
}) {
  const [opts, setOpts] = useState<Array<{ id: string; label: string }> | null>(null);
  const [err, setErr] = useState('');

  const openPicker = async () => {
    try {
      const all = await threads();
      const name = new Map(all.map((t) => [t.id, t.name]));
      setOpts(all.filter((t) => t.id !== x.thread_id && t.status === 'active')
        .map((t) => ({ id: t.id, label: t.parent_id ? `${name.get(t.parent_id) ?? ''} › ${t.name}` : t.name }))
        .sort((a, b) => a.label.localeCompare(b.label, 'hu')));
    } catch (e: any) { setErr(e.message); }
  };
  const move = async (to: string) => {
    if (!to) return;
    try {
      await api(`/api/decisions/${x.event_id}`, to === '-' ? { thread: x.thread_id, action: 'none' } : { thread: x.thread_id, action: 'move', to });
      cache = null;
      onMoved?.();
    } catch (e: any) { setErr(e.message); }
  };

  return (
    <div className="j-panel j-dec j-c-coral place-card">
      <div className="meta">Ez az esemény · {day(x.occurred_at)} · {KIND[x.kind] ?? x.kind}</div>
      <p className="ev">{x.text}</p>
      <div className="meta">Ebben a szálban van</div>
      <h3>{x.parent ? <span className="parent">{x.parent} › </span> : null}{x.thread}</h3>
      <div className="meta ask-q">Ide tartozik?</div>
      {opts ? (
        <div className="j-row">
          <select className="j-input" defaultValue="" autoFocus onChange={(e) => move(e.target.value)}>
            <option value="" disabled>Melyik szálhoz tartozik?</option>
            <option value="-">— Egyik szálhoz sem —</option>
            {opts.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
          </select>
          <button className="j-btn" onClick={() => setOpts(null)}>Mégse</button>
        </div>
      ) : (
        <div className="j-row">
          <button className="j-btn j-btn--primary" onClick={() => onAnswer('ok')}>Igen</button>
          <button className="j-btn" onClick={() => onAnswer('none')}>Nem tartozik szálhoz</button>
          <button className="j-btn" onClick={openPicker}>Máshová…</button>
        </div>
      )}
      {err && <p className="err">{err}</p>}
    </div>
  );
}
